import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
  createSeatingArea,
  deleteSeatingArea,
  updateSeatingArea,
} from '../../../store/SeatingAreaReducer'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const SeatingAreaForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.seatingArea)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createSeatingArea(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateSeatingArea(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteSeatingArea(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

SeatingAreaForm.displayName = 'SeatingAreaForm'

export default SeatingAreaForm
